import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/camera")({
	component: RouteComponent,
});

function RouteComponent() {
	return <Outlet />;
}
